import { useCopiedState } from "../../../../core/util/hooks";
import { setFilter, removeFilter, initialState } from "../../../domestic/trades/tradesUXSlice"
import { invalidateTrades } from "../../../domestic/trades/tradesDataSlice"
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";
import { TradeFilter } from "../../../domestic/trades/types";


export const useTradesFilter = () => {
	const storeFilter = useSelector<StoreType, TradeFilter>(store => store.ux.domestic.trades.filter);
	const [filter, editFilter, changeState, setCurrentFilter] = useCopiedState<TradeFilter>(storeFilter);

	const dispatch = useDispatch();
	const dispatchSetFilter = React.useCallback(() => {
		dispatch(setFilter(filter!))
		dispatch(invalidateTrades())
	}, [dispatch, filter])

	const dispatchResetFilter = React.useCallback(() => {
		setCurrentFilter(initialState.filter)
	}, [setCurrentFilter])

	return [
		filter,
		editFilter,
		dispatchSetFilter,
		changeState, 
		dispatchResetFilter
	] as [
		typeof filter,
		typeof editFilter,
		typeof dispatchSetFilter,
		typeof changeState,
		typeof dispatchResetFilter
	]
};

export const useCurrentTradesFilter = () => {
	const filter = useSelector<StoreType, TradeFilter>(store => store.ux.domestic.trades.filter);
	const dispatch = useDispatch();
	const dispatchRemoveFilter = React.useCallback(
		(type: keyof TradeFilter) => {
			dispatch(removeFilter(type));
			dispatch(invalidateTrades());
		},
		[dispatch]
	);

	return [filter, dispatchRemoveFilter] as [typeof filter, typeof dispatchRemoveFilter];
};
